import io from 'socket.io-client';

export default class RedisService {
    constructor(userId) {
        this.socket = this.getSocketUrl();
        this.userId = userId;
    }

    getSocketUrl() {
        const protocol = import.meta.env.VITE_API_SECURITY || 'http';
        const host = import.meta.env.VITE_API_ENDPOINT;
        const isDev = import.meta.env.VITE_APP_ENV === 'dev';

        const url = isDev
            ? `${protocol}://${host}:${import.meta.env.VITE_APP_SOCKET_IO_PORT}`
            : `${protocol}://${host}`;

        return io(url, {
            path: '/ws',
            transports: ['websocket'],
            forceNew: true,
            reconnection: true
        });
    }

    listenForKeyUpdates(key, callback) {
        this.socket.on(`${import.meta.env.VITE_APP_ENV}_cache-channel:cache-updated`, (message) => {
            if (message.key === key) {
                callback(message.data);
            }
        });

        // this.socket.on("connect", () => {
        //     console.log(`Socket connected for: ${key}`);
        // });
        //
        // this.socket.on("disconnect", (reason, description) => {
        //     console.log(`Socket disconnected, reason: ${reason}, description: `, description);
        // });
        //
        this.socket.on("connect_error", (err) => {
            if (import.meta.env.VITE_APP_ENV === 'dev') {
                console.log(`[Debug] connect_error due to ${err.message}`);
            }
        });
        //
        // this.socket.onAny((event) => {
        //     console.log(`ANY ${event}`);
        // });
    }

    handleRouteChange(user, newRoute) {
        this.socket.emit('routeChange', { user: user, route: newRoute });
    }

    handleDeleteUser() {
        this.socket.emit('userDisconnected', { userId: this.userId });
    }

    disconnect() {
        this.handleDeleteUser()
        this.socket.disconnect();
    }

    getUserActivities(callback) {
        this.socket.emit('getUserActivities', (response) => {
            callback(response);
        });
    }
}
